module.exports = __webpack_public_path__ + "static/media/10260.1363eab4.jpg";